module.exports = __webpack_public_path__ + "img/student-bg.9ed6e763.jpg";